import { Coins, Handshake, GlobeHemisphereWest } from '@phosphor-icons/react';
import { useTranslation } from '@eti/providers';
import { vars } from '@etg/wings';
import UniqueSellingPointWrapper from './UniqueSellingPointWrapper';
import UniqueSellingPoint from './UniqueSellingPoint';

const MainUniqueSellingPoint = ({ className }: { className?: string }) => {
  const { t } = useTranslation();
  const iconColor = vars.colors.decoration.primary;
  return (
    <UniqueSellingPointWrapper className={className} dataTestId="main-usp">
      <UniqueSellingPoint
        icon={
          <Coins aria-hidden color={iconColor} data-testid="coin-icon" size={38} weight="duotone" />
        }
        title={t('StartPage.USPOne.Title')}
      />
      <UniqueSellingPoint
        icon={
          <Handshake
            aria-hidden
            color={iconColor}
            data-testid="handshake-icon"
            size={38}
            weight="duotone"
          />
        }
        title={t('StartPage.USPTwo.Title')}
      />
      <UniqueSellingPoint
        icon={
          <GlobeHemisphereWest
            aria-hidden
            color={iconColor}
            data-testid="globe-icon"
            size={38}
            weight="duotone"
          />
        }
        title={t('StartPage.USPThree.Title')}
      />
    </UniqueSellingPointWrapper>
  );
};

export default MainUniqueSellingPoint;
